module.exports = __webpack_public_path__ + "static/media/homer.8f658032.jpg";